<template >
  <div
      class="form-check form-switch"
  >
    <input
        v-model="inputModel"
        class="form-check-input"
        type="checkbox"
        role="switch"
        :id="inputObj.name + '_switch'"

        :disabled="(this.inputObj.readonly)? 'disabled': false"
        :readonly="(this.inputObj.readonly)? 'readonly': false"
    >
    <label
        v-if="inputObj.templates && inputObj.templates.title"
        class="form-check-label"
        :for="inputObj.name + '_switch'"
    >
      {{ inputObj.templates.title }}
    </label>
  </div>



</template>

<script>

export default {
  name: "BooleanInput",
  props: {
    "inputObj": Object,
    "formObj": Object,
    "modelValue": [Boolean, Number, String],
    "activeLang": {
      type: [String],
      required: false,
      default: null,
    },
  },
  data() {
    return {
      inputModel: null,
      timer: null,
      timer_delay: 500,
    }
  },
  mounted() {
    if(this.inputObj.val == 1 || this.inputObj.val == true ) {
      this.inputModel = true;
    }else{
      this.inputModel = false;
    }
    this.$emit('update:modelValue', this.inputModel )
  },


  methods: {
  },
  watch: {
    inputObj: {
      handler() {
        this.inputModel = this.inputObj.val;
      },
      deep: true,
      immediate: true
    },
    inputModel( newVal){
      this.$emit('update:modelValue', newVal )
    },
  },
};
</script>